
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Bulk Order</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="bulkOrder?.projectId &amp;&amp; bulkOrder?.projectName"><a [routerLink]="['/project']" [queryParams]="{id: bulkOrder?.projectId}">{{ bulkOrder?.projectName }}</a></li>
        <li class="breadcrumb-item" *ngIf="bulkOrder?.projectId"><a [routerLink]="['/bulk-orderings']" [queryParams]="{projectId: bulkOrder?.projectId}">Bulk Orders</a></li>
        <li class="breadcrumb-item active" *ngIf="bulkOrder?.name">{{ bulkOrder?.name }}</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card-item" *ngIf="bulkOrder">
        <h4>{{ bulkOrder.name }}</h4>
        <property-container>
          <property-item><a [href]="'/#/workflow/' + bulkOrder.workflowId">Set Up Bulk Order</a></property-item>
        </property-container>
        <property-container>
          <property-item [showIf]="bulkOrder.hardwareOrderDate">Hardware Order Date: {{ bulkOrder.hardwareOrderDate | date: 'yyyy-MM-dd' : 'UTC'}}</property-item>
        </property-container>
        <property-container class="red">
          <property-item [showIf]="bulkOrder.pastSchedule"><span class="oi oi-clock"></span> {{ bulkOrder.pastSchedulePopover }}</property-item>
        </property-container>
        <property-container class="red">
          <property-item [showIf]="bulkOrder.shippedLateDevices &gt; 0"><span class="oi oi-clock"></span> {{ bulkOrder.shippedLateDevices + " assets are set to be ordered past the hardware order date" }}</property-item>
        </property-container>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>